<template>
  <div>
    <h2>答题明细</h2>
    <el-table :data="tableData" border style="width: 100%" v-loading="loading">
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="student_id" label="学生ID" width="100"></el-table-column>
      <el-table-column prop="student_name" label="用户名" width="150"></el-table-column>
      <el-table-column prop="mode" label="练习模式"></el-table-column>
      <el-table-column prop="content" label="题目内容"></el-table-column>
      <el-table-column prop="is_correct" label="是否正确">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_correct ? 'success' : 'danger'">{{ scope.row.is_correct ? '正确' : '错误' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="答题时间" width="180"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import api from '@/api'
export default {
  data() { return { tableData: [], loading: false } },
  created() { this.fetchData() },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await api.getQuestionAttempts({skip:0, limit:100});
        this.tableData = res.items || [];
      } catch (e) { console.error(e) }
      finally { this.loading = false; }
    }
  }
}
</script>